import { formatJstFromUtc } from 'admin/utils';
import { components } from '../../../schema/docs/api/admin';

type IndividualNumberIdentification = components['schemas']['IndividualNumberIdentification'];

// CSV は react-csv に headers を渡していないため、boolean の false が空欄として
// 書き出される (react-csv の elementOrEmpty)。空欄だと運用者が「未認証」なのか
// 値が入っていないのかを読み取れないので、状態は日本語の文字列にしてから渡す
export const formatIdentificationStatus = (isIdentified: boolean | undefined) =>
  isIdentified ? '認証済' : '未認証';

// 住民判定は3値。null (まだ判定していない) を「非住民」と同じ表示にしない
export const formatResidentStatus = (isResident: boolean | null | undefined) => {
  if (isResident === true) return '住民';
  if (isResident === false) return '非住民';
  return '判定なし';
};

/**
 * 顧客一覧 API の 1 行を CSV の 1 行に変換する。
 *
 * - ネストした individual_number_identification は CSV の列にできないのでフラット化する
 * - 列名は individual_number_ で名前空間を切る。発行体が任意に定義できる個人属性が
 *   ...rest でそのまま列になるため、素の is_resident のような名前だと衝突して
 *   黙って上書きしてしまう
 */
export const toCsvRow = (row: Record<string, unknown>): Record<string, unknown> => {
  const {
    account_is_suspended: _accountIsSuspended,
    individual_number_identification: rawIdentification,
    ...rest
  } = row;
  const identification = rawIdentification as IndividualNumberIdentification | undefined;

  return {
    ...rest,
    last_transaction_done_at: formatJstFromUtc(row?.last_transaction_done_at),
    registered_at: formatJstFromUtc(row.registered_at),
    individual_number_identification: formatIdentificationStatus(identification?.is_identified),
    individual_number_identified_at: formatJstFromUtc(identification?.last_identified_at),
    individual_number_expires_at: formatJstFromUtc(identification?.expires_at),
    individual_number_resident: formatResidentStatus(identification?.is_resident),
  };
};
